import { AccountDatasource } from '../datasources/account_datasource';
import { ICommand, IDefineCommand } from 'core-ts-types';
import { IPhxStateService } from 'utility-ng-configuration';

angular.module('capability-ng-user-app').factory(
  'logoutNotificationCommand',
  (logoutCommand: ICommand, defineCommand: IDefineCommand, log: any, $state: IPhxStateService): ICommand => {
    return defineCommand('logoutNotificationCommand', function(deferred: ng.IDeferred<any>): void {
      logoutCommand()
        .then(() => {
          deferred.resolve();
          log.user.success({
            name: `log-out-message`,
            content: `You have logged out and your work has been saved.`,
            timeout: 10000,
            dismissOnTimeout: true,
            dismissButton: true
          });
        })
        .catch(deferred.reject)
        .finally(() => {
          $state.go('landing');
        })
        .catch(deferred.reject);
    });
  }
);



// WEBPACK FOOTER //
// ./app/lib/user_app/commands/logout_notification_command.ts